let slickDefaults = require('../slick-default/slick-default');
require('./cat-slider.less');

let size = require('../../modules/size');

jQuery(function() {
    $('.js-slick-cat-slider').each(function() {
        var $this = $(this);

        $this.slick(
            $.extend({}, slickDefaults.params, {
                slidesToShow: 4,
                responsive: [
                    {
                        breakpoint: size.desktop,
                        settings: { slidesToShow: 4 }
                    },
                    {
                        breakpoint: size.tabletBig,
                        settings: { slidesToShow: 2, dots: true }
                    },
                    {
                        breakpoint: size.tablet,
                        settings: { slidesToShow: 2, dots: true }
                    },
                    {
                        breakpoint: size.mobileBig,
                        settings: { slidesToShow: 1, dots: true }
                    }
                ]
            })
        );
    });
});



// WEBPACK FOOTER //
// ./blocks/cat-slider/cat-slider.js